import { Center } from "@chakra-ui/react";
import ApproachList from "../Containers/ApproachList";

const Approach = () => (
  <Center>
    <ApproachList />
  </Center>
);
export default Approach;
